import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  Output,
} from '@angular/core';
import {
  AppState,
  FilterState,
  LivingSpaceFilterState,
  LivingSpaceRange,
  RangeSliderOption,
} from '@immosky/types';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import {
  isLivingSpaceFilterActive,
  selectFilterState,
} from '@immosky/object-search-filter';

@Component({
  selector: 'lib-living-space-filter',
  templateUrl: './living-space-filter.component.html',
  styleUrls: ['./living-space-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LivingSpaceFilterComponent implements OnDestroy {
  private subscriptions: Subscription[] = [];

  options: RangeSliderOption[] = [];
  currentFilter!: LivingSpaceRange;
  livingSpaceFilterState!: LivingSpaceFilterState;

  @Output()
  update = new EventEmitter<LivingSpaceRange>();

  get canReset(): boolean {
    return isLivingSpaceFilterActive(
      this.currentFilter,
      this.livingSpaceFilterState.default
    );
  }

  constructor(
    private cdRef: ChangeDetectorRef,
    private store: Store<AppState>
  ) {
    const subscription = this.store
      .pipe(select(selectFilterState))
      .subscribe((filterState: FilterState) => {
        this.livingSpaceFilterState = filterState.livingSpace;
        this.currentFilter = {
          ...this.livingSpaceFilterState.filter,
        };
        this.options = this.livingSpaceFilterState.options;
        this.cdRef.markForCheck();
      });

    this.subscriptions.push(subscription);
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  reset() {
    this.currentFilter.min = this.options[0];
    this.currentFilter.max = this.options[this.options.length - 1];
    this.emitChange();
  }

  selectMin(option: RangeSliderOption) {
    this.currentFilter.min = option;
    this.emitChange();
  }

  selectMax(option: RangeSliderOption) {
    this.currentFilter.max = option;
    this.emitChange();
  }

  emitChange() {
    this.update.emit(this.currentFilter);
  }
}
